import { render, staticRenderFns } from "./Compensations.vue?vue&type=template&id=6041a00a"
import script from "./Compensations.vue?vue&type=script&lang=js"
export * from "./Compensations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports